import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the scroll position whenever the route changes, so a new page always
 * starts at the top the way a normal document navigation would.
 */
export const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
};
